import React from 'react';
import './Team.css';
import BannerTitle from '../../../Components/BannerTitle/BannerTitle';
import Footer from '../../Shared/Footer/Footer';
import { Nav, Navbar } from 'react-bootstrap';


const Team = (props) => {


    return (
        <>
            <div className='topBar'>
                <Navbar expand="lg" fixed="top" className="nav" style={{ background: "#272727" }} >

                    <div className='navContainer '>

                        <>
                            <Navbar.Brand className='navLogo2'>
                                <Nav.Link href="/">

                                    <img width={75} src="https://webredox.net/demo/wp/bauen/light/el/multi/demo1/wp-content/uploads/2021/09/logo.png" alt="" />
                                </Nav.Link>

                            </Navbar.Brand>

                        </>


                    </div>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="" >
                        <Nav className="ms-auto">
                            <Nav.Link href="/" className="navLink">Home</Nav.Link>
                        </Nav>
                        <Nav >
                            <Nav.Link href="/#about" className="navLink">About Us</Nav.Link>
                        </Nav>
                        <Nav className="">
                            <Nav.Link href="/#projects" className="navLink">Projects</Nav.Link>
                        </Nav>
                        <Nav className="">
                            <Nav.Link href="/#onGoingProjects" className="navLink">On Going Projects</Nav.Link>
                        </Nav>
                        <Nav className="">
                            <Nav.Link href="/#services" className="navLink">Services</Nav.Link>
                        </Nav>
                        <Nav className="">
                            <Nav.Link href="/#team" className="navLink">Our Team</Nav.Link>
                        </Nav>
                        <Nav className="" style={{ marginRight: "75px" }}>
                            <Nav.Link href="/#contact" className="navLink">Contact Us</Nav.Link>
                        </Nav>

                    </Navbar.Collapse>
                </Navbar>
            </div>
            <div className="">

                <div className="teamBannerContainer">
                    <BannerTitle title1="Our" title2="Team" />
                </div>
                <div className='teams container'>

                    <>
                        <div className="row">
                            <>
                                <div className="row">

                                    {
                                        props.team.sort((a, b) => a.serial - b.serial).map(team =>
                                            <div key={team.serial} className='col-lg-4 col-md-6 teamCard'>
                                                <div className="inner">
                                                    <img className='teamCardImg' src={team.img} alt="" width="100%" />
                                                </div>
                                                <div className='teamCardTitleContainer' >
                                                    <h5 className='teamCardName'>{team.name}</h5>
                                                    <p className='teamCardDesignation'>{team.designation}</p>
                                                    {
                                                        team.study ? <p className='teamCardStudy'>{team.study} <br />
                                                        </p> : <></>
                                                    }
                                                    {
                                                        team.membership ? <span className='teamCardStudy'>{team.membership}</span> : <></>
                                                    }
                                                </div>
                                            </div>)
                                    }
                                </div>
                            </>
                        </div>
                    </>

                </div>
            </div>
            <Footer />
        </>
    );
};

export default Team;